import { defineMessages } from 'react-intl';

export default defineMessages({
    summaryDrivers: {
        id: 'ml.quoteandbind.common.policySummary.Drivers',
        defaultMessage: 'Drivers'
    },
    summaryEditDrivers: {
        id: 'ml.quoteandbind.common.policySummary.Edit Drivers',
        defaultMessage: 'Edit Drivers'
    },
    summaryDriverName: {
        id: 'ml.quoteandbind.common.policySummary.drivers.NAME',
        defaultMessage: 'NAME'
    },
    summaryDriverGender: {
        id: 'ml.quoteandbind.common.policySummary.drivers.GENDER',
        defaultMessage: 'GENDER'
    },
    summaryDriverDateOfBirth: {
        id: 'ml.quoteandbind.common.policySummary.drivers.DATE OF BIRTH',
        defaultMessage: 'DATE OF BIRTH'
    },
    summaryDriverMaritalStatus: {
        id: 'ml.quoteandbind.common.policySummary.drivers.MARITAL STATUS',
        defaultMessage: 'MARITAL STATUS'
    },
    summaryHouseholdMembers: {
        id: 'ml.quoteandbind.common.policySummary.Household Members',
        defaultMessage: 'Household Members'
    },
    summaryExclusions: {
        id: 'ml.quoteandbind.common.policySummary.Exclusions',
        defaultMessage: 'Exclusions'
    },
    summaryExclusionsStatement: {
        id: 'ml.quoteandbind.common.policySummary.You\'ve selected to exclude coverage for the following drivers:',
        defaultMessage: 'You\'ve selected to exclude coverage for the following drivers:'
    },
    summaryDriverPfm: {
        id: 'ml.quoteandbind.common.policySummary.driver.PFM',
        defaultMessage: 'PFM'
    },
    houseHoldMemberHeader: {
        id: "ml.quoteandbind.common.policySummary.Household Members",
        defaultMessage: "Household Members"
    },
    nonDriversHeader: {
        id: "ml.quoteandbind.common.policySummary.Non Drivers",
        defaultMessage: "Non Drivers"
    }
});
